/**
 * Tells Brocoded's relay, as a category only, that a connection problem happened, so the admin page can see issues
 * reaching users. Sends {kind, reason} from fixed lists and the app version: no computer, account, address, IP or text.
 * Best effort, rate limited per kind, never throws.
 */
const RELAY_HTTP: string = (import.meta.env.VITE_RELAY_URL ?? "").replace(/\/+$/, "");
const last = new Map<string, number>();
const MIN_GAP_MS = 60_000;

export function reportConnection(kind: "stale" | "offline" | "unauthorized" | "pairing_failed" | "diagnostics" | "recovered", reason: string): void {
  try {
    if (!RELAY_HTTP) return;
    const key = `${kind}:${reason}`;
    const now = Date.now();
    if (now - (last.get(key) ?? 0) < MIN_GAP_MS) return; // a flapping link must not flood the relay
    last.set(key, now);
    const body = JSON.stringify({ version: String(import.meta.env.VITE_APP_VERSION ?? "dev"), events: [{ kind, reason }] });
    void fetch(`${RELAY_HTTP}/diag`, { method: "POST", headers: { "content-type": "application/json" }, body, keepalive: true }).catch(() => undefined);
  } catch {
    /* reporting must never cause a problem */
  }
}
